module.exports = __webpack_public_path__ + "static/media/fastGamesPlayed_10000_50000.13e59e09.png";